import React, { PureComponent } from 'react';
import { Button, Icon } from 'semantic-ui-react';
import './List.css';
import { multiValueAttributeUpdater } from './utils/handler';
import message from '../../../helper/message';

class ButtonGroup extends PureComponent {
  render() {
    const { disabled, text, onChange, number } = this.props;
    return (
      <Button.Group style={{ width: '100%' }}>
        <Button
          disabled={disabled}
          basic
          color="black"
          style={{ width: '50%', cursor: 'auto' }}
        >
          {text}
        </Button>
        <Button
          className="plusButton"
          icon
          onClick={onChange(1)}
          disabled={disabled}
        >
          <Icon name="add" />
        </Button>
        <Button
          disabled={disabled}
          basic
          color="black"
          style={{ cursor: 'auto' }}
        >
          {number}
        </Button>
        <Button
          className="minusButton"
          icon
          onClick={onChange(-1)}
          disabled={disabled || !number}
        >
          <Icon name="minus" />
        </Button>
      </Button.Group>
    );
  }
}

export default class List extends PureComponent {
  onChange = ({ value }) => change => () => {
    multiValueAttributeUpdater(this.props, value, change);
  };

  render() {
    const {
      configuration,
      attributeName,
      appApi,
      options,
      onChange,
      disabled,
    } = this.props;
    const { label, autoHide } = appApi.config.getAttribute(attributeName);
    const listOptions =
      options ||
      appApi.config.getAttributeAvailableValues(attributeName, configuration);

    if (autoHide && !listOptions.length) return <div />;
    // for dev, remove in product mode
    onChange &&
      message.warn(
        `The onchange function for ${attributeName} has been override, please take care of the import disable inside override function!`
      );
    ///////////////
    return (
      <div className="attrContainer listAttrContainer">
        {label && <div className="listLabel label">{label}</div>}
        {listOptions.map(option => {
          return (
            <ButtonGroup
              key={option.value}
              disabled={disabled || option.disabled}
              text={option.text}
              onChange={(onChange && onChange(option)) || this.onChange(option)}
              number={
                typeof option.number === 'number'
                  ? option.number
                  : configuration[attributeName][option.value].length
              }
            />
          );
        })}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Attributes/standardAttributes/List.js